import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line
import classNames from "classnames";

class Tooltip extends React.Component {
  render() {
    const {
      width,
      arrow,
      position,
      classNameContainer,
      classNameText,
      classNameContent,
      text,
      content,
      children,
      className,
      ...extraProps
    } = this.props;

    let style = {};

    if (width > 0) {
      style.width = width;
    }

    const tooltipClasses = classNames(
      "tooltip",
      {
        [`position-${position}`]: position,
        arrow: arrow
      },
      classNameContainer
    );

    if (content) {
      const contentClasses = classNames("tooltip-content", classNameContent);

      return (
        <div className={tooltipClasses} {...(extraProps || {})}>
          {children}
          <div className={contentClasses} style={style}>
            {content}
          </div>
        </div>
      );
    } else {
      const textClasses = classNames("tooltip-text", classNameText);

      return (
        <div className={tooltipClasses} {...(extraProps || {})}>
          {children}
          <div className={textClasses} style={style}>
            {text}
          </div>
        </div>
      );
    }
  }
}

Tooltip.defaultProps = {
  width: null,
  arrow: false,
  position: "top",
  classNameText: "",
  classNameContent: "",
  classNameContainer: "",
  text: "",
  content: null,
  children: null
};

Tooltip.propTypes = {
  width: PropTypes.number,
  arrow: PropTypes.bool,
  position: PropTypes.oneOf([
    "top",
    "top-left",
    "top-right",
    "left",
    "left-top",
    "left-bottom",
    "right",
    "right-top",
    "right-bottom",
    "bottom",
    "bottom-left",
    "bottom-right"
  ]),
  classNameText: PropTypes.string,
  classNameContent: PropTypes.string,
  classNameContainer: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  content: PropTypes.node,
  children: PropTypes.node.isRequired
};

export default Tooltip;
